import axios from 'axios';
import { useAuthStore } from '../store/authStore';

declare module 'axios' {
  export interface AxiosRequestConfig {
    skipAuthRedirect?: boolean;
  }
}

const API_URL = process.env.REACT_APP_API_URL || 'https://ourora-core-975242939572.asia-south1.run.app';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      // Handle unauthorized - clear auth state and redirect to login
      try {
        const { logout } = useAuthStore.getState();
        logout();
      } catch {
        // Fallback in case store is not available for some reason
        localStorage.removeItem('token');
      }
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);

export default api;
